"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPolicyHardCopy = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const look_up_entity_1 = require("./look-up.entity");
const policy_hard_copy_document_map_entity_1 = require("./policy-hard-copy-document-map.entity");
let OpportunityPolicyHardCopy = class OpportunityPolicyHardCopy {
    constructor(opportunityId, activityId, opportunityActivityId, statusLid, insurerPolicyNo, hardCopyReceivedOn, deviationsLid, brokeragePercentage, premium, deviationCoveragesLid, coverages, exclusions, deductibles, deviationsAddressedLid, resolutionLid, policyHardCopyReceivedLid, remarks, createdBy, updatedBy, createdAt, updatedAt) {
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.opportunityActivityId = opportunityActivityId;
        this.statusLid = statusLid;
        this.insurerPolicyNo = insurerPolicyNo;
        this.hardCopyReceivedOn = hardCopyReceivedOn;
        this.deviationsLid = deviationsLid;
        this.brokeragePercentage = brokeragePercentage;
        this.premium = premium;
        this.deviationCoveragesLid = deviationCoveragesLid;
        this.coverages = coverages;
        this.exclusions = exclusions;
        this.deductibles = deductibles;
        this.deviationsAddressedLid = deviationsAddressedLid;
        this.resolutionLid = resolutionLid;
        this.policyHardCopyReceivedLid = policyHardCopyReceivedLid;
        this.remarks = remarks;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
};
exports.OpportunityPolicyHardCopy = OpportunityPolicyHardCopy;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "insurer_policy_no",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyHardCopy.prototype, "insurerPolicyNo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "hard_copy_received_on", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityPolicyHardCopy.prototype, "hardCopyReceivedOn", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "deviations_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "deviationsLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "brokerage_percentage",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyHardCopy.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "premium", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyHardCopy.prototype, "premium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "deviation_coverages_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "deviationCoveragesLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "coverages", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyHardCopy.prototype, "coverages", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "exclusions", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyHardCopy.prototype, "exclusions", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "deductibles", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyHardCopy.prototype, "deductibles", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "deviations_addressed_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "deviationsAddressedLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "resolution_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "resolutionLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "policy_hard_copy_received_lid",
        type: "int",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "policyHardCopyReceivedLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyHardCopy.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyHardCopy.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], OpportunityPolicyHardCopy.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], OpportunityPolicyHardCopy.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "SET NULL",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyHardCopy.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyHardCopy.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "deviations_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyHardCopy.prototype, "deviations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "deviation_coverages_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyHardCopy.prototype, "deviationCoverages", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "deviations_addressed_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyHardCopy.prototype, "deviationsAddressed", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "resolution_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyHardCopy.prototype, "resolution", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({
        name: "policy_hard_copy_received_lid",
        referencedColumnName: "id",
    }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyHardCopy.prototype, "revisedPolicyHardCopyReceived", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_hard_copy_document_map_entity_1.PolicyHardCopyDocumentMap, (documentMap) => documentMap.policyHardCopy, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityPolicyHardCopy.prototype, "documents", void 0);
exports.OpportunityPolicyHardCopy = OpportunityPolicyHardCopy = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_policy_hard_copy"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, String, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, Number, String, String, Number, String, String, String, Number, Number, Number, String, Number, Number, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object])
], OpportunityPolicyHardCopy);
